import { Toaster } from "@/components/ui/sonner";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import Application from "@/pages/Application";
import ApplicationWithdraw from "@/pages/ApplicationWithdraw";
import ErrorBoundary from "@/components/ErrorBoundary";

function App() {
  return (
    <div className="App">
      <ErrorBoundary>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/application/:token" element={<Application />} />
            <Route path="/application/:token/withdraw" element={<ApplicationWithdraw />} />
            <Route path="/application" element={<Navigate to="/" replace />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </ErrorBoundary>
      <Toaster position="top-center" theme="dark" richColors />
    </div>
  );
}

export default App;
